/* gd-guide.js (WS-GUIDEVIS): tap-to-check signs list. Vanilla, no observers (motion is plentum-motion.js). Works without JS: checkboxes still tick. */
(function () {
  var f = document.querySelector('[data-gd-check]');
  if (!f) return;
  var n = f.querySelector('[data-gd-n]'), m = f.querySelector('[data-gd-msg]');
  function upd() {
    var c = f.querySelectorAll('input[type=checkbox]:checked').length;
    n.textContent = c;
    m.textContent = c === 0 ? 'Nothing ticked yet.' : c < 3 ? 'Note when it happens for a week and mention it to your vet.' : 'That is a lot to track. A vet visit is a good next step.';
  }
  f.addEventListener('change', upd);
  upd();
})();
